import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Card from '../../../components/ui/Card';
import Icon from '../../../components/AppIcon';

const RenewalForecastChart = ({ data }) => {
  const formatCurrency = (value) => {
    return `₹${(value / 1000)?.toFixed(0)}K`;
  };

  return (
    <Card className="p-6">
      <div className="mb-6">
        <h2 className="text-xl font-bold text-foreground mb-2">Renewal Forecast</h2>
        <p className="text-sm text-muted-foreground">
          Predicted lease expirations and renewal risk over the next 12 months
        </p>
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <AreaChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis dataKey="month" stroke="#6b7280" />
          <YAxis stroke="#6b7280" />
          <Tooltip
            contentStyle={{
              backgroundColor: '#ffffff',
              border: '1px solid #e5e7eb',
              borderRadius: '8px'
            }}
          />
          <Legend />
          <Area
            type="monotone"
            dataKey="highRisk"
            stackId="1"
            stroke="#ef4444"
            fill="#ef4444"
            name="High Risk"
          />
          <Area
            type="monotone"
            dataKey="mediumRisk"
            stackId="1"
            stroke="#f59e0b"
            fill="#f59e0b"
            name="Medium Risk"
          />
          <Area
            type="monotone"
            dataKey="lowRisk"
            stackId="1"
            stroke="#10b981"
            fill="#10b981"
            name="Low Risk"
          />
        </AreaChart>
      </ResponsiveContainer>

      <div className="mt-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Next 3 Months Forecast</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {data?.slice(0, 3)?.map((month, index) => (
            <div key={index} className="p-4 border border-border rounded-lg">
              <div className="flex items-center justify-between mb-3">
                <p className="font-medium text-foreground">{month?.month}</p>
                <Icon name="Calendar" size={20} className="text-muted-foreground" />
              </div>
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-muted-foreground">Total Expiring:</span>
                  <span className="font-semibold">{month?.totalExpiring}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-red-600">High Risk:</span>
                  <span className="font-semibold text-red-600">{month?.highRisk}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-muted-foreground">Revenue at Risk:</span>
                  <span className="font-semibold">₹{month?.revenueAtRisk?.toLocaleString()}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
};

export default RenewalForecastChart;